export const couchBaseURL = location.origin + process.env.VUE_APP_BACKEND_PREFIX + "db-";
export const checkLoginPath = process.env.VUE_APP_BACKEND_PREFIX + "check_login/";
export const collaboratorsPath = process.env.VUE_APP_BACKEND_PREFIX + "collaborators/";
export const loginPath = process.env.VUE_APP_BACKEND_PREFIX + "accounts/login";
export const logoutPath = process.env.VUE_APP_BACKEND_PREFIX + "accounts/logout/";

export function getCsrfToken() {
  // Returns undefined if the cookie is missing.
  return (/csrftoken=([^;]*)/.exec(document.cookie) || [])[1];
}

export async function postToEndpoint(url) {
  // Returns undefined if the cookie is missing.
  const token = getCsrfToken();
  let response, result;

  try {
    response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": token,
      },
      body: JSON.stringify({}),
    });
  } catch (err) {
    console.error(err);
    return {};
  }

  if (response.status >= 400) {
    console.error(response);
    return {};
  }

  try {
    result = await response.json();
  } catch (err) {
    console.error(err);
    return {};
  }

  console.debug(url, "->", result);
  return result;
}

// Redirect to login page, with the current url set as next.
export function redirectToLogin(message) {
  window.alert(message);
  window.location.href = loginPath + `?next=${encodeURIComponent(location.href)}`;
}

export function couchFetchOverride(url, options) {
  // No cache for database communication.
  options.cache = "no-store";
  options.headers.append("X-CSRFToken", getCsrfToken());
  return fetch(url, options).then((response) => {
    if (response.status == 403) {
      console.error("HTTP 403 returned by db. Checking login...");
      postToEndpoint(checkLoginPath).then(
        (response) => {
          if (!response.body.login) {
            // TODO: Check for login change, not just missing login...
            console.error("Logged out, reloading...");
            redirectToLogin("Session expired, you have to log in again.");
          }
        },
        (err) => {
          console.error("Login check failed:", err);
          console.error("reloading...");
          redirectToLogin("You have to log in again.");
        },
      );
    }
    return response;
  });
}
